module.exports = __webpack_public_path__ + "static/media/INDY XC 137 - RED BLACK - merged.fcfde0cf.glb";